define('widgets/pages',[
	'jquery',
	'modules/page',
	'lib/jquery-ui/widget',
], function ($, page) {

	return $.widget('muse.pages', {

		options: {
		},

		_create: function () {

			this._on({
				'click .hint': function (e) {
					$(e.currentTarget).prev('input, textarea').focus();
				}
			});

			this.$wrap = this.element.find('.wrap');
			this.$page = this.$wrap.find('.page');

			this.calc();
			this._on(page.$win, {
				scroll: $.proxy(this, 'onScroll'),
				resized: $.proxy(this, 'onResize')
			});

			$.subscribe('navChange', $.proxy(this, 'onNavChange'));

			return this._super();

		},

		onScroll: function () {

			this.check();

		},

		onResize: function () {

			this.calc();

		},

		calc: function () {

			var $page = this.$page,
				coords = {
					win: page.$win.height(),
					wrap: {},
					page: {}
				};

			$.each(this.$wrap, function (i) {

				var $el = $(this),
					name = $el.attr('class').split(' ').pop();

				coords.wrap[i] = $.extend({
					height: $el.height()
				}, $el.offset());

				coords.page[i] = {
					height: $page.eq(i).outerHeight()
				};

			});

			this.coords = coords;
			this.check();

		},

		check: function () {

			var scroll = page.$win.scrollTop(),
				coords = this.coords;

			$.each(this.$page, function (i) {

				var $el = $(this),
					// offset = -100;
					offset = coords.page[i].height - coords.win;

				if (coords.win + scroll >= coords.wrap[i].height - offset) {
					$el.css({
						position: 'absolute',
						top: 'auto',
						left: 'auto',
						bottom: 0
					});
				} else {
					$el.css({
						position: 'fixed',
						top: coords.wrap[i].top,
						left: coords.wrap[i].left,
						bottom: 'auto'
					});
				}

			});

		},

		onNavChange: function (e, enabled) {

			if (!enabled) this.calc();

		}

	});

});
